import { render, staticRenderFns } from "./ElementStructurePreview.vue?vue&type=template&id=8ce264bc&scoped=true&"
import script from "./ElementStructurePreview.vue?vue&type=script&lang=js&"
export * from "./ElementStructurePreview.vue?vue&type=script&lang=js&"
import style0 from "./ElementStructurePreview.vue?vue&type=style&index=0&id=8ce264bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce264bc",
  null
  
)

export default component.exports